"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.uiControls = exports.trackingStatuses = exports.states = exports.predicates = exports.machineId = exports.events = exports.apiResponseStates = exports.SEARCH_TYPE_HEAD_SUGGESTED_CATEGORIES = exports.Easing = void 0;
// ui controls
const uiControls = exports.uiControls = {
  MULTI_SELECT: 'MultiSelect',
  BUTTON_LIST: 'ButtonList',
  YES_NO_BUTTONS: 'YesNoButtons',
  DOB: 'non_data_backed_date',
  SINGLE_CHOICE_BUTTONS: 'simple_select',
  CLINICAL_SEARCH: 'text'
};
const machineId = exports.machineId = 'gx_next';
const states = exports.states = {
  doneLeft: 'doneLeft',
  doneRight: 'doneRight',
  init: '@state/INIT',
  idle: '@state/IDLE',
  error: '@state/ERROR',
  done: '@state/DONE',
  pending: '@state/PENDING',
  warning: '@state/WARNING',
  skipped: '@state/SKIPPED'
};
const trackingStatuses = exports.trackingStatuses = {
  INCOMPLETE: 'incomplete',
  FAIL: 'fail',
  ERROR: 'error',
  SUCCESS: 'success'
};
const apiResponseStates = exports.apiResponseStates = {
  WARNING: 'Warning',
  DONE: 'Done'
};
const events = exports.events = {
  SUBMIT: 'SUBMIT',
  REVERT: 'REVERT',
  ANSWER: 'ANSWER'
};

// predicates used as guards
const predicates = exports.predicates = {
  ANSWER_INCLUDES_ALL: 'answerIncludesAll',
  ANSWER_INCLUDES_ANY: 'answerIncludesAny',
  PROVIDER_SPECIALTY_INCLUDES_ALL: 'providerSpecialtyIncludesAll',
  PROVIDER_KCL_TERMS_INCLUDES_ALL: 'providerKCLTermsIncludesAll',
  COMPOSE_COND: 'composeCond'
};
const Easing = exports.Easing = {
  /** Quintic easing in/out - accelerates until midpoint, then decelerates
   * See https://easings.net/#easeInOutQuint */
  easeInOutQuint: [0.83, 0, 0.17, 1]
};
const SEARCH_TYPE_HEAD_SUGGESTED_CATEGORIES = exports.SEARCH_TYPE_HEAD_SUGGESTED_CATEGORIES = [
// v8 categories
'clinical_combined', 'clinical_experience', 'name', 'network_affiliation', 'practice_group', 'practice_location', 'primary_care', 'primary_care_condition', 'provider_name', 'specialty', 'specialty_strict', 'specialty_synonym',
// v9 categories
'clinical_keywords', 'conditions_symptoms', 'location_name', 'marketable_locations', 'marketable_location_type', 'marketable_location_services', 'specialties', 'treatments_procedures', 'unified'];